import newBusinessPdf from './components/new-business-pdf';

newBusinessPdf.init({
  pdfPathHex: 'L3dwLWNvbnRlbnQvdXBsb2Fkcy8yMDI1LzA4L09uZV9QYWdlX0Nhc2UucGRmI3BkZmpzLmFjdGlvbj1kb3dubG9hZA==',
  videoPaths: null,
});
